// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file inbox/inbox.proto (package lvdr.v2.inbox, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AiMark } from "../common/aimark_pb";
import { file_common_aimark } from "../common/aimark_pb";
import type { LimitCut } from "../errors/errors_pb";
import { file_errors_errors } from "../errors/errors_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inbox/inbox.proto.
 */
export const file_inbox_inbox: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_duration, file_google_protobuf_timestamp, file_common_aimark, file_errors_errors]);

/**
 * @generated from message lvdr.v2.inbox.Interaction
 */
export type Interaction = Message<"lvdr.v2.inbox.Interaction"> & {
  /**
   * "ix_" + 32 hex; always equal to contract.InteractionID(source.adapter,
   * source.account_ref, source.native_ref). The log recomputes and refuses a mismatch.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Starts at 1. The log refuses 0 and anything newer than contract.SchemaVersion.
   *
   * @generated from field: uint32 schema_version = 2;
   */
  schemaVersion: number;

  /**
   * @generated from field: lvdr.v2.inbox.SourceRef source = 3;
   */
  source?: SourceRef | undefined;

  /**
   * @generated from field: string conversation_id = 4;
   */
  conversationId: string;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 5;
   */
  occurredAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp edited_at = 6;
   */
  editedAt?: Timestamp | undefined;

  /**
   * @generated from field: bool deleted = 7;
   */
  deleted: boolean;

  /**
   * @generated from field: lvdr.v2.inbox.Direction direction = 8;
   */
  direction: Direction;

  /**
   * @generated from field: repeated lvdr.v2.inbox.Participant participants = 9;
   */
  participants: Participant[];

  /**
   * @generated from field: string reply_to_ref = 10;
   */
  replyToRef: string;

  /**
   * @generated from field: repeated lvdr.v2.inbox.ContentPart parts = 11;
   */
  parts: ContentPart[];

  /**
   * @generated from field: string language = 12;
   */
  language: string;

  /**
   * @generated from field: lvdr.v2.inbox.FilterVerdict filter = 13;
   */
  filter?: FilterVerdict | undefined;

  /**
   * @generated from field: string raw_ref = 14;
   */
  rawRef: string;

  /**
   * "mh_" + 32 hex of sha256 over the trimmed, lower-cased Message-ID without angle brackets (contract.MessageIDHash). Empty when the item has none. INBOX-05b; additive (SchemaVersion stays 1).
   *
   * @generated from field: string message_id_hash = 15;
   */
  messageIdHash: string;

  /**
   * The subject line the inbound filter screened, one line, at most contract.MaxSubjectBytes (contract.CapSubject). Empty for items without a subject.
   *
   * @generated from field: string subject = 16;
   */
  subject: string;

  /**
   * Sorted, de-duplicated tokens from contract.NoiseHintValues(): which list/bulk/auto headers were present. Header NAMES and fixed tokens only, never header values.
   *
   * @generated from field: repeated string noise_hints = 17;
   */
  noiseHints: string[];

  /**
   * LIMIT-32: every field the intake adapter cut on import (limitcap.Cut). Empty when nothing was cut. Additive (SchemaVersion stays 1).
   *
   * @generated from field: repeated lvdr.v2.errors.LimitCut import_cuts = 18;
   */
  importCuts: LimitCut[];

  /**
   * LIMIT-32: set only on the server-authored notice a push drain lands for drops it could not deliver.
   *
   * @generated from field: lvdr.v2.inbox.IntakeDropNotice drop_notice = 19;
   */
  dropNotice?: IntakeDropNotice | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.Interaction.
 * Use `create(InteractionSchema)` to create a new message.
 */
export const InteractionSchema: GenMessage<Interaction> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 0);

/**
 * @generated from message lvdr.v2.inbox.SourceRef
 */
export type SourceRef = Message<"lvdr.v2.inbox.SourceRef"> & {
  /**
   * @generated from field: lvdr.v2.inbox.Kind kind = 1;
   */
  kind: Kind;

  /**
   * Canonical lowercase token, ^[a-z][a-z0-9_-]*$ (contract.SourceKey.Valid).
   *
   * @generated from field: string adapter = 2;
   */
  adapter: string;

  /**
   * The adapter's canonical mailbox identifier (imap: the lowercased, trimmed address).
   *
   * @generated from field: string account_ref = 3;
   */
  accountRef: string;

  /**
   * Stable id of the item within (adapter, account_ref).
   *
   * @generated from field: string native_ref = 4;
   */
  nativeRef: string;

  /**
   * @generated from field: string deep_link = 5;
   */
  deepLink: string;
};

/**
 * Describes the message lvdr.v2.inbox.SourceRef.
 * Use `create(SourceRefSchema)` to create a new message.
 */
export const SourceRefSchema: GenMessage<SourceRef> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 1);

/**
 * @generated from message lvdr.v2.inbox.Participant
 */
export type Participant = Message<"lvdr.v2.inbox.Participant"> & {
  /**
   * @generated from field: lvdr.v2.inbox.Handle handle = 1;
   */
  handle?: Handle | undefined;

  /**
   * @generated from field: lvdr.v2.inbox.Role role = 2;
   */
  role: Role;

  /**
   * INBOX-04 (D4): exact typed handles the SOURCE verified for this participant
   * (03b: a Slack user's profile email). Never DISPLAY_NAME or SPEAKER_LABEL.
   *
   * @generated from field: repeated lvdr.v2.inbox.Handle aliases = 3;
   */
  aliases: Handle[];

  /**
   * INBOX-04 (D2): display only, capped by contract.CapDisplayName; never merge evidence.
   *
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * INBOX-04 (D3): this participant is the user. At most one per Interaction; empty means UNKNOWN.
   *
   * @generated from field: bool self = 5;
   */
  self: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.Participant.
 * Use `create(ParticipantSchema)` to create a new message.
 */
export const ParticipantSchema: GenMessage<Participant> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 2);

/**
 * INBOX-04: a derived contact (internal/inbox/analysis/identity), stored under ct/d/c/ in inbox.db.
 * Never written to the log.
 *
 * @generated from message lvdr.v2.inbox.Contact
 */
export type Contact = Message<"lvdr.v2.inbox.Contact"> & {
  /**
   * "ct_" + 32 hex of the smallest member handle key (D1)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * members, in handle-key order
   *
   * @generated from field: repeated lvdr.v2.inbox.Handle handles = 2;
   */
  handles: Handle[];

  /**
   * most frequent capped name; ties → byte-smallest
   *
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * EMAIL member domains, sorted, unique
   *
   * @generated from field: repeated string domains = 4;
   */
  domains: string[];
};

/**
 * Describes the message lvdr.v2.inbox.Contact.
 * Use `create(ContactSchema)` to create a new message.
 */
export const ContactSchema: GenMessage<Contact> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 3);

/**
 * @generated from message lvdr.v2.inbox.Handle
 */
export type Handle = Message<"lvdr.v2.inbox.Handle"> & {
  /**
   * @generated from field: lvdr.v2.inbox.HandleKind kind = 1;
   */
  kind: HandleKind;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message lvdr.v2.inbox.Handle.
 * Use `create(HandleSchema)` to create a new message.
 */
export const HandleSchema: GenMessage<Handle> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 4);

/**
 * @generated from message lvdr.v2.inbox.ContentPart
 */
export type ContentPart = Message<"lvdr.v2.inbox.ContentPart"> & {
  /**
   * @generated from field: lvdr.v2.inbox.PartType type = 1;
   */
  type: PartType;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * Has presence: "speaker 0" is distinguishable from "not a transcript part".
   *
   * @generated from field: optional int32 speaker_idx = 3;
   */
  speakerIdx?: number | undefined;

  /**
   * @generated from field: google.protobuf.Duration t_start = 4;
   */
  tStart?: Duration | undefined;

  /**
   * @generated from field: google.protobuf.Duration t_end = 5;
   */
  tEnd?: Duration | undefined;

  /**
   * @generated from field: string attachment_ref = 6;
   */
  attachmentRef: string;
};

/**
 * Describes the message lvdr.v2.inbox.ContentPart.
 * Use `create(ContentPartSchema)` to create a new message.
 */
export const ContentPartSchema: GenMessage<ContentPart> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 5);

/**
 * LIMIT-32: one reason's count of push-channel items that could not be delivered.
 *
 * @generated from message lvdr.v2.inbox.IntakeDropCount
 */
export type IntakeDropCount = Message<"lvdr.v2.inbox.IntakeDropCount"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;

  /**
   * @generated from field: int64 count = 2;
   */
  count: bigint;
};

/**
 * Describes the message lvdr.v2.inbox.IntakeDropCount.
 * Use `create(IntakeDropCountSchema)` to create a new message.
 */
export const IntakeDropCountSchema: GenMessage<IntakeDropCount> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 6);

/**
 * LIMIT-32: the drop notice a push drain lands in the Inbox (D83). Counts and times only, no content.
 *
 * @generated from message lvdr.v2.inbox.IntakeDropNotice
 */
export type IntakeDropNotice = Message<"lvdr.v2.inbox.IntakeDropNotice"> & {
  /**
   * @generated from field: string channel = 1;
   */
  channel: string;

  /**
   * @generated from field: repeated lvdr.v2.inbox.IntakeDropCount counts = 2;
   */
  counts: IntakeDropCount[];

  /**
   * @generated from field: google.protobuf.Timestamp first_at = 3;
   */
  firstAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_at = 4;
   */
  lastAt?: Timestamp | undefined;

  /**
   * retry window in force when the notice was built; 0 = not known
   *
   * @generated from field: int64 horizon_seconds = 5;
   */
  horizonSeconds: bigint;

  /**
   * retry buffer cap in force; 0 = not known
   *
   * @generated from field: int64 cap = 6;
   */
  cap: bigint;
};

/**
 * Describes the message lvdr.v2.inbox.IntakeDropNotice.
 * Use `create(IntakeDropNoticeSchema)` to create a new message.
 */
export const IntakeDropNoticeSchema: GenMessage<IntakeDropNotice> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 7);

/**
 * Recorded by the adapter from the InboundFilter result, never recomputed.
 * decision/threat_score mirror domain.FilterResult.Decision/ThreatScore;
 * content_source mirrors domain.ContentSource.
 *
 * @generated from message lvdr.v2.inbox.FilterVerdict
 */
export type FilterVerdict = Message<"lvdr.v2.inbox.FilterVerdict"> & {
  /**
   * @generated from field: string decision = 1;
   */
  decision: string;

  /**
   * @generated from field: double threat_score = 2;
   */
  threatScore: number;

  /**
   * @generated from field: string content_source = 3;
   */
  contentSource: string;
};

/**
 * Describes the message lvdr.v2.inbox.FilterVerdict.
 * Use `create(FilterVerdictSchema)` to create a new message.
 */
export const FilterVerdictSchema: GenMessage<FilterVerdict> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 8);

/**
 * The IMAP connection settings. NEVER carries the secret on a response.
 *
 * @generated from message lvdr.v2.inbox.InboxMailboxSettings
 */
export type InboxMailboxSettings = Message<"lvdr.v2.inbox.InboxMailboxSettings"> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string;

  /**
   * @generated from field: string host = 2;
   */
  host: string;

  /**
   * @generated from field: uint32 port = 3;
   */
  port: number;

  /**
   * @generated from field: string username = 4;
   */
  username: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxMailboxSettings.
 * Use `create(InboxMailboxSettingsSchema)` to create a new message.
 */
export const InboxMailboxSettingsSchema: GenMessage<InboxMailboxSettings> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 9);

/**
 * @generated from message lvdr.v2.inbox.InboxFolderProgress
 */
export type InboxFolderProgress = Message<"lvdr.v2.inbox.InboxFolderProgress"> & {
  /**
   * "inbox" | "sent"
   *
   * @generated from field: string role = 1;
   */
  role: string;

  /**
   * @generated from field: uint32 backfill_done = 2;
   */
  backfillDone: number;

  /**
   * @generated from field: uint32 backfill_total = 3;
   */
  backfillTotal: number;
};

/**
 * Describes the message lvdr.v2.inbox.InboxFolderProgress.
 * Use `create(InboxFolderProgressSchema)` to create a new message.
 */
export const InboxFolderProgressSchema: GenMessage<InboxFolderProgress> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 10);

/**
 * @generated from message lvdr.v2.inbox.InboxSourceStatus
 */
export type InboxSourceStatus = Message<"lvdr.v2.inbox.InboxSourceStatus"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxSyncState state = 1;
   */
  state: InboxSyncState;

  /**
   * @generated from field: google.protobuf.Timestamp last_sync_at = 2;
   */
  lastSyncAt?: Timestamp | undefined;

  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode last_error_code = 3;
   */
  lastErrorCode: InboxErrorCode;

  /**
   * @generated from field: repeated lvdr.v2.inbox.InboxFolderProgress folders = 4;
   */
  folders: InboxFolderProgress[];

  /**
   * @generated from field: repeated string folders_found = 5;
   */
  foldersFound: string[];
};

/**
 * Describes the message lvdr.v2.inbox.InboxSourceStatus.
 * Use `create(InboxSourceStatusSchema)` to create a new message.
 */
export const InboxSourceStatusSchema: GenMessage<InboxSourceStatus> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 11);

/**
 * One source = (adapter kind, account). imap sets mailbox; other kinds (INBOX-03 "call") leave it unset.
 *
 * @generated from message lvdr.v2.inbox.InboxSource
 */
export type InboxSource = Message<"lvdr.v2.inbox.InboxSource"> & {
  /**
   * @generated from field: string adapter = 1;
   */
  adapter: string;

  /**
   * @generated from field: string account_ref = 2;
   */
  accountRef: string;

  /**
   * @generated from field: lvdr.v2.inbox.InboxMailboxSettings mailbox = 3;
   */
  mailbox?: InboxMailboxSettings | undefined;

  /**
   * @generated from field: lvdr.v2.inbox.InboxSourceStatus status = 4;
   */
  status?: InboxSourceStatus | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp added_at = 5;
   */
  addedAt?: Timestamp | undefined;

  /**
   * INBOX-23: the user's name for the mailbox; "" = none (show the address). <= 40 runes, no control characters.
   *
   * @generated from field: string label = 6;
   */
  label: string;

  /**
   * INBOX-23: 1-based palette index (--mailbox-<n>); 0 = not yet assigned.
   *
   * @generated from field: int32 color = 7;
   */
  color: number;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSource.
 * Use `create(InboxSourceSchema)` to create a new message.
 */
export const InboxSourceSchema: GenMessage<InboxSource> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 12);

/**
 * @generated from message lvdr.v2.inbox.InboxListMailboxesRequest
 */
export type InboxListMailboxesRequest = Message<"lvdr.v2.inbox.InboxListMailboxesRequest"> & {
};

/**
 * Describes the message lvdr.v2.inbox.InboxListMailboxesRequest.
 * Use `create(InboxListMailboxesRequestSchema)` to create a new message.
 */
export const InboxListMailboxesRequestSchema: GenMessage<InboxListMailboxesRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 13);

/**
 * @generated from message lvdr.v2.inbox.InboxListMailboxesResponse
 */
export type InboxListMailboxesResponse = Message<"lvdr.v2.inbox.InboxListMailboxesResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.inbox.InboxSource sources = 1;
   */
  sources: InboxSource[];

  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 2;
   */
  errorCode: InboxErrorCode;

  /**
   * INBOX-17: true when the caller is not on the inbox allowlist; the client renders Disconnect only.
   *
   * @generated from field: bool manage_only = 3;
   */
  manageOnly: boolean;

  /**
   * INBOX-23 D13: the stored /inbox mailbox filter; absent = All. Set only when it names a listed source.
   *
   * @generated from field: lvdr.v2.inbox.InboxAccount filter = 4;
   */
  filter?: InboxAccount | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxListMailboxesResponse.
 * Use `create(InboxListMailboxesResponseSchema)` to create a new message.
 */
export const InboxListMailboxesResponseSchema: GenMessage<InboxListMailboxesResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 14);

/**
 * @generated from message lvdr.v2.inbox.InboxTestMailboxRequest
 */
export type InboxTestMailboxRequest = Message<"lvdr.v2.inbox.InboxTestMailboxRequest"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxMailboxSettings settings = 1;
   */
  settings?: InboxMailboxSettings | undefined;

  /**
   * app password; <= 1 KiB; never stored by Test
   *
   * @generated from field: string secret = 2;
   */
  secret: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxTestMailboxRequest.
 * Use `create(InboxTestMailboxRequestSchema)` to create a new message.
 */
export const InboxTestMailboxRequestSchema: GenMessage<InboxTestMailboxRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 15);

/**
 * @generated from message lvdr.v2.inbox.InboxTestMailboxResponse
 */
export type InboxTestMailboxResponse = Message<"lvdr.v2.inbox.InboxTestMailboxResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 2;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: repeated string folders_found = 3;
   */
  foldersFound: string[];
};

/**
 * Describes the message lvdr.v2.inbox.InboxTestMailboxResponse.
 * Use `create(InboxTestMailboxResponseSchema)` to create a new message.
 */
export const InboxTestMailboxResponseSchema: GenMessage<InboxTestMailboxResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 16);

/**
 * @generated from message lvdr.v2.inbox.InboxConnectMailboxRequest
 */
export type InboxConnectMailboxRequest = Message<"lvdr.v2.inbox.InboxConnectMailboxRequest"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxMailboxSettings settings = 1;
   */
  settings?: InboxMailboxSettings | undefined;

  /**
   * @generated from field: string secret = 2;
   */
  secret: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxConnectMailboxRequest.
 * Use `create(InboxConnectMailboxRequestSchema)` to create a new message.
 */
export const InboxConnectMailboxRequestSchema: GenMessage<InboxConnectMailboxRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 17);

/**
 * @generated from message lvdr.v2.inbox.InboxConnectMailboxResponse
 */
export type InboxConnectMailboxResponse = Message<"lvdr.v2.inbox.InboxConnectMailboxResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 2;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: lvdr.v2.inbox.InboxSource source = 3;
   */
  source?: InboxSource | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxConnectMailboxResponse.
 * Use `create(InboxConnectMailboxResponseSchema)` to create a new message.
 */
export const InboxConnectMailboxResponseSchema: GenMessage<InboxConnectMailboxResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 18);

/**
 * @generated from message lvdr.v2.inbox.InboxDisconnectMailboxRequest
 */
export type InboxDisconnectMailboxRequest = Message<"lvdr.v2.inbox.InboxDisconnectMailboxRequest"> & {
  /**
   * @generated from field: string account_ref = 1;
   */
  accountRef: string;

  /**
   * "" => "imap"; INBOX-03 sends "call"
   *
   * @generated from field: string adapter = 2;
   */
  adapter: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxDisconnectMailboxRequest.
 * Use `create(InboxDisconnectMailboxRequestSchema)` to create a new message.
 */
export const InboxDisconnectMailboxRequestSchema: GenMessage<InboxDisconnectMailboxRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 19);

/**
 * @generated from message lvdr.v2.inbox.InboxDisconnectMailboxResponse
 */
export type InboxDisconnectMailboxResponse = Message<"lvdr.v2.inbox.InboxDisconnectMailboxResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 2;
   */
  errorCode: InboxErrorCode;

  /**
   * record gone; the log purge finishes in the background (marker-guarded); an InboxSyncProgress with removed=true follows
   *
   * @generated from field: bool purge_started = 3;
   */
  purgeStarted: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.InboxDisconnectMailboxResponse.
 * Use `create(InboxDisconnectMailboxResponseSchema)` to create a new message.
 */
export const InboxDisconnectMailboxResponseSchema: GenMessage<InboxDisconnectMailboxResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 20);

/**
 * INBOX-03: the per-user "Include call transcripts" switch. On = a {adapter:"call", account_ref: lower(user id)} source
 * row exists. enabled=true is gated on inbox_intelligence + recordings_asr; enabled=false is NEVER flag-gated and is
 * idempotent (off when already off answers ok).
 *
 * @generated from message lvdr.v2.inbox.InboxSetCallSourceRequest
 */
export type InboxSetCallSourceRequest = Message<"lvdr.v2.inbox.InboxSetCallSourceRequest"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetCallSourceRequest.
 * Use `create(InboxSetCallSourceRequestSchema)` to create a new message.
 */
export const InboxSetCallSourceRequestSchema: GenMessage<InboxSetCallSourceRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 21);

/**
 * @generated from message lvdr.v2.inbox.InboxSetCallSourceResponse
 */
export type InboxSetCallSourceResponse = Message<"lvdr.v2.inbox.InboxSetCallSourceResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 2;
   */
  errorCode: InboxErrorCode;

  /**
   * on only: the row (status IDLE, or the stored row when it was already on)
   *
   * @generated from field: lvdr.v2.inbox.InboxSource source = 3;
   */
  source?: InboxSource | undefined;

  /**
   * off: a removal was started by THIS request
   *
   * @generated from field: bool purge_started = 4;
   */
  purgeStarted: boolean;

  /**
   * off: a removal is still finishing (another op holds the source, or the run did not stop
   *
   * @generated from field: bool purge_pending = 5;
   */
  purgePending: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetCallSourceResponse.
 * Use `create(InboxSetCallSourceResponseSchema)` to create a new message.
 */
export const InboxSetCallSourceResponseSchema: GenMessage<InboxSetCallSourceResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 22);

/**
 * Connect: gated on inbox_intelligence + inbox_telegram (per user) and the workflow tier. Mints a one-time /start
 * token; the first Connect also adds the {telegram, account_ref} source record.
 *
 * @generated from message lvdr.v2.inbox.InboxTelegramConnectRequest
 */
export type InboxTelegramConnectRequest = Message<"lvdr.v2.inbox.InboxTelegramConnectRequest"> & {
  /**
   * @generated from field: string consent_version = 1;
   */
  consentVersion: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxTelegramConnectRequest.
 * Use `create(InboxTelegramConnectRequestSchema)` to create a new message.
 */
export const InboxTelegramConnectRequestSchema: GenMessage<InboxTelegramConnectRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 23);

/**
 * @generated from message lvdr.v2.inbox.InboxTelegramConnectResponse
 */
export type InboxTelegramConnectResponse = Message<"lvdr.v2.inbox.InboxTelegramConnectResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 2;
   */
  errorCode: InboxErrorCode;

  /**
   * https://t.me/<bot>?start=<token>; shown once, never stored in plaintext
   *
   * @generated from field: string deep_link = 3;
   */
  deepLink: string;

  /**
   * @generated from field: string account_ref = 4;
   */
  accountRef: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxTelegramConnectResponse.
 * Use `create(InboxTelegramConnectResponseSchema)` to create a new message.
 */
export const InboxTelegramConnectResponseSchema: GenMessage<InboxTelegramConnectResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 24);

/**
 * @generated from message lvdr.v2.inbox.InboxTelegramStatusRequest
 */
export type InboxTelegramStatusRequest = Message<"lvdr.v2.inbox.InboxTelegramStatusRequest"> & {
};

/**
 * Describes the message lvdr.v2.inbox.InboxTelegramStatusRequest.
 * Use `create(InboxTelegramStatusRequestSchema)` to create a new message.
 */
export const InboxTelegramStatusRequestSchema: GenMessage<InboxTelegramStatusRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 25);

/**
 * @generated from message lvdr.v2.inbox.InboxTelegramStatusResponse
 */
export type InboxTelegramStatusResponse = Message<"lvdr.v2.inbox.InboxTelegramStatusResponse"> & {
  /**
   * TELEGRAM_ALREADY_LINKED when the newest /start was refused
   *
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: lvdr.v2.inbox.InboxTelegramLinkState state = 2;
   */
  state: InboxTelegramLinkState;

  /**
   * @generated from field: bool can_reply = 3;
   */
  canReply: boolean;

  /**
   * @generated from field: bool extra_rights = 4;
   */
  extraRights: boolean;

  /**
   * @generated from field: string bot_username = 5;
   */
  botUsername: string;

  /**
   * @generated from field: string account_ref = 6;
   */
  accountRef: string;

  /**
   * LIMIT-32: items waiting in the retry buffer for this user; 0 also when not known
   *
   * @generated from field: int64 parked = 7;
   */
  parked: bigint;

  /**
   * LIMIT-32: how long a parked item is kept; 0 = not known
   *
   * @generated from field: int64 retry_horizon_seconds = 8;
   */
  retryHorizonSeconds: bigint;
};

/**
 * Describes the message lvdr.v2.inbox.InboxTelegramStatusResponse.
 * Use `create(InboxTelegramStatusResponseSchema)` to create a new message.
 */
export const InboxTelegramStatusResponseSchema: GenMessage<InboxTelegramStatusResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 26);

/**
 * off answered with neither purge flag => it was already off.
 * Server push, one per page of a run, and one with removed=true when a disconnect purge completes.
 *
 * @generated from message lvdr.v2.inbox.InboxSyncProgress
 */
export type InboxSyncProgress = Message<"lvdr.v2.inbox.InboxSyncProgress"> & {
  /**
   * @generated from field: string adapter = 1;
   */
  adapter: string;

  /**
   * @generated from field: string account_ref = 2;
   */
  accountRef: string;

  /**
   * @generated from field: lvdr.v2.inbox.InboxSourceStatus status = 3;
   */
  status?: InboxSourceStatus | undefined;

  /**
   * @generated from field: bool removed = 4;
   */
  removed: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSyncProgress.
 * Use `create(InboxSyncProgressSchema)` to create a new message.
 */
export const InboxSyncProgressSchema: GenMessage<InboxSyncProgress> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 27);

/**
 * @generated from message lvdr.v2.inbox.TriageConversation
 */
export type TriageConversation = Message<"lvdr.v2.inbox.TriageConversation"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * "email" | "chat"
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * UNSPECIFIED when inbox_triage is off
   *
   * @generated from field: lvdr.v2.inbox.TriageBucket bucket = 3;
   */
  bucket: TriageBucket;

  /**
   * first contact's display_name, else its first handle value, else ""
   *
   * @generated from field: string contact_name = 4;
   */
  contactName: string;

  /**
   * latest row's capped subject (<=120 B); never body text
   *
   * @generated from field: string subject = 5;
   */
  subject: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_activity = 6;
   */
  lastActivity?: Timestamp | undefined;

  /**
   * asks to the user whose ledger status is not tombstoned
   *
   * @generated from field: int32 open_asks = 7;
   */
  openAsks: number;

  /**
   * the user's stored label, UNSPECIFIED if none
   *
   * @generated from field: lvdr.v2.inbox.TriageBucket label = 8;
   */
  label: TriageBucket;

  /**
   * newest open ask title (<=200 B, from the ledger)
   *
   * @generated from field: string top_ask = 9;
   */
  topAsk: string;

  /**
   * INBOX-23: the conversation's mailbox; absent = not known yet (a store not rebuilt to v5)
   *
   * @generated from field: lvdr.v2.inbox.InboxAccount account = 10;
   */
  account?: InboxAccount | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.TriageConversation.
 * Use `create(TriageConversationSchema)` to create a new message.
 */
export const TriageConversationSchema: GenMessage<TriageConversation> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 28);

/**
 * @generated from message lvdr.v2.inbox.ConvRuleProposal
 */
export type ConvRuleProposal = Message<"lvdr.v2.inbox.ConvRuleProposal"> & {
  /**
   * exactly one id: ProposeRule emits single-contact rules only
   *
   * @generated from field: repeated string contact_ids = 1;
   */
  contactIds: string[];

  /**
   * ceiling: domains reserved; ProposeRule emits single-contact rules only (rev1 D-I7); a domain proposal needs a UI that names the domain
   *
   * @generated from field: repeated string domains = 2;
   */
  domains: string[];

  /**
   * @generated from field: lvdr.v2.inbox.TriageBucket bucket = 3;
   */
  bucket: TriageBucket;

  /**
   * INBOX-20b: email and chat conversations whose bucket the confirmed rule would change (PreviewConvRules over the
   * set Confirm writes). Unset = not known (rules unreadable or the preview failed); never sent as 0 for "unknown".
   *
   * @generated from field: optional int32 would_move = 4;
   */
  wouldMove?: number | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.ConvRuleProposal.
 * Use `create(ConvRuleProposalSchema)` to create a new message.
 */
export const ConvRuleProposalSchema: GenMessage<ConvRuleProposal> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 29);

/**
 * @generated from message lvdr.v2.inbox.TriageReportCell
 */
export type TriageReportCell = Message<"lvdr.v2.inbox.TriageReportCell"> & {
  /**
   * @generated from field: lvdr.v2.inbox.TriageBucket label = 1;
   */
  label: TriageBucket;

  /**
   * @generated from field: lvdr.v2.inbox.TriageBucket predicted = 2;
   */
  predicted: TriageBucket;

  /**
   * @generated from field: int32 count = 3;
   */
  count: number;
};

/**
 * Describes the message lvdr.v2.inbox.TriageReportCell.
 * Use `create(TriageReportCellSchema)` to create a new message.
 */
export const TriageReportCellSchema: GenMessage<TriageReportCell> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 30);

/**
 * @generated from message lvdr.v2.inbox.InboxListTriageRequest
 */
export type InboxListTriageRequest = Message<"lvdr.v2.inbox.InboxListTriageRequest"> & {
  /**
   * a task link's interaction id (ix_...), resolved to its conversation
   *
   * @generated from field: string focus_interaction_id = 1;
   */
  focusInteractionId: string;

  /**
   * @generated from field: string focus_conversation_id = 2;
   */
  focusConversationId: string;

  /**
   * INBOX-22: only conversations whose FIRST matching rule of the current set (re-evaluated, not the stored
   * MatchedRule) is this zero-based index; the final "otherwise" rule is len-1. Unset = no filter. Needs inbox_triage.
   *
   * @generated from field: optional int32 rule_index = 3;
   */
  ruleIndex?: number | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxListTriageRequest.
 * Use `create(InboxListTriageRequestSchema)` to create a new message.
 */
export const InboxListTriageRequestSchema: GenMessage<InboxListTriageRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 31);

/**
 * @generated from message lvdr.v2.inbox.InboxListTriageResponse
 */
export type InboxListTriageResponse = Message<"lvdr.v2.inbox.InboxListTriageResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: repeated lvdr.v2.inbox.TriageConversation conversations = 2;
   */
  conversations: TriageConversation[];

  /**
   * inbox_triage on
   *
   * @generated from field: bool buckets_enabled = 3;
   */
  bucketsEnabled: boolean;

  /**
   * analysis has run at least once (an/v present)
   *
   * @generated from field: bool has_state = 4;
   */
  hasState: boolean;

  /**
   * extraction or triage queue non-empty
   *
   * @generated from field: bool catching_up = 5;
   */
  catchingUp: boolean;

  /**
   * resolved from either focus field; "" if unknown
   *
   * @generated from field: string focused_conversation_id = 6;
   */
  focusedConversationId: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxListTriageResponse.
 * Use `create(InboxListTriageResponseSchema)` to create a new message.
 */
export const InboxListTriageResponseSchema: GenMessage<InboxListTriageResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 32);

/**
 * @generated from message lvdr.v2.inbox.InboxSetTriageLabelRequest
 */
export type InboxSetTriageLabelRequest = Message<"lvdr.v2.inbox.InboxSetTriageLabelRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: lvdr.v2.inbox.TriageBucket bucket = 2;
   */
  bucket: TriageBucket;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetTriageLabelRequest.
 * Use `create(InboxSetTriageLabelRequestSchema)` to create a new message.
 */
export const InboxSetTriageLabelRequestSchema: GenMessage<InboxSetTriageLabelRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 33);

/**
 * @generated from message lvdr.v2.inbox.InboxSetTriageLabelResponse
 */
export type InboxSetTriageLabelResponse = Message<"lvdr.v2.inbox.InboxSetTriageLabelResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: bool has_proposal = 2;
   */
  hasProposal: boolean;

  /**
   * @generated from field: lvdr.v2.inbox.ConvRuleProposal proposal = 3;
   */
  proposal?: ConvRuleProposal | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetTriageLabelResponse.
 * Use `create(InboxSetTriageLabelResponseSchema)` to create a new message.
 */
export const InboxSetTriageLabelResponseSchema: GenMessage<InboxSetTriageLabelResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 34);

/**
 * @generated from message lvdr.v2.inbox.InboxConfirmRuleProposalRequest
 */
export type InboxConfirmRuleProposalRequest = Message<"lvdr.v2.inbox.InboxConfirmRuleProposalRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: lvdr.v2.inbox.TriageBucket bucket = 2;
   */
  bucket: TriageBucket;

  /**
   * the proposal's contact the dialog showed; the server refuses a mismatch
   *
   * @generated from field: string contact_id = 3;
   */
  contactId: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxConfirmRuleProposalRequest.
 * Use `create(InboxConfirmRuleProposalRequestSchema)` to create a new message.
 */
export const InboxConfirmRuleProposalRequestSchema: GenMessage<InboxConfirmRuleProposalRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 35);

/**
 * @generated from message lvdr.v2.inbox.InboxConfirmRuleProposalResponse
 */
export type InboxConfirmRuleProposalResponse = Message<"lvdr.v2.inbox.InboxConfirmRuleProposalResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * the rule is saved; buckets update on the next pass
   *
   * @generated from field: bool retriage_deferred = 2;
   */
  retriageDeferred: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.InboxConfirmRuleProposalResponse.
 * Use `create(InboxConfirmRuleProposalResponseSchema)` to create a new message.
 */
export const InboxConfirmRuleProposalResponseSchema: GenMessage<InboxConfirmRuleProposalResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 36);

/**
 * @generated from message lvdr.v2.inbox.InboxGetTriageCountRequest
 */
export type InboxGetTriageCountRequest = Message<"lvdr.v2.inbox.InboxGetTriageCountRequest"> & {
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetTriageCountRequest.
 * Use `create(InboxGetTriageCountRequestSchema)` to create a new message.
 */
export const InboxGetTriageCountRequestSchema: GenMessage<InboxGetTriageCountRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 37);

/**
 * @generated from message lvdr.v2.inbox.InboxGetTriageCountResponse
 */
export type InboxGetTriageCountResponse = Message<"lvdr.v2.inbox.InboxGetTriageCountResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetTriageCountResponse.
 * Use `create(InboxGetTriageCountResponseSchema)` to create a new message.
 */
export const InboxGetTriageCountResponseSchema: GenMessage<InboxGetTriageCountResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 38);

/**
 * Server push: the open needs-me count, after every analysis pass and every label/confirm.
 *
 * @generated from message lvdr.v2.inbox.InboxTriageCount
 */
export type InboxTriageCount = Message<"lvdr.v2.inbox.InboxTriageCount"> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number;
};

/**
 * Describes the message lvdr.v2.inbox.InboxTriageCount.
 * Use `create(InboxTriageCountSchema)` to create a new message.
 */
export const InboxTriageCountSchema: GenMessage<InboxTriageCount> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 39);

/**
 * @generated from message lvdr.v2.inbox.InboxGetTriageReportRequest
 */
export type InboxGetTriageReportRequest = Message<"lvdr.v2.inbox.InboxGetTriageReportRequest"> & {
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetTriageReportRequest.
 * Use `create(InboxGetTriageReportRequestSchema)` to create a new message.
 */
export const InboxGetTriageReportRequestSchema: GenMessage<InboxGetTriageReportRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 40);

/**
 * @generated from message lvdr.v2.inbox.InboxGetTriageReportResponse
 */
export type InboxGetTriageReportResponse = Message<"lvdr.v2.inbox.InboxGetTriageReportResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: int32 labelled = 2;
   */
  labelled: number;

  /**
   * label vs the rule bucket stored at label time
   *
   * @generated from field: repeated lvdr.v2.inbox.TriageReportCell at_label = 3;
   */
  atLabel: TriageReportCell[];

  /**
   * label vs the conversation's current bucket
   *
   * @generated from field: repeated lvdr.v2.inbox.TriageReportCell now = 4;
   */
  now: TriageReportCell[];

  /**
   * absent when no NEEDS_ME label exists
   *
   * @generated from field: optional double needs_me_recall_at_label = 5;
   */
  needsMeRecallAtLabel?: number | undefined;

  /**
   * @generated from field: optional double needs_me_recall_now = 6;
   */
  needsMeRecallNow?: number | undefined;

  /**
   * absent when nothing was predicted NEEDS_ME at label time
   *
   * @generated from field: optional double needs_me_precision_at_label = 7;
   */
  needsMePrecisionAtLabel?: number | undefined;

  /**
   * true once a rule was confirmed (the conversation rule set is the user's,
   * not the default table); absent when the stored rule set cannot be read.
   * The recall runbook's "rule set is default" precondition reads this.
   *
   * @generated from field: optional bool rules_customized = 8;
   */
  rulesCustomized?: boolean | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetTriageReportResponse.
 * Use `create(InboxGetTriageReportResponseSchema)` to create a new message.
 */
export const InboxGetTriageReportResponseSchema: GenMessage<InboxGetTriageReportResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 41);

/**
 * ---- INBOX-20b: clear-label (Undo of a first move) and the "Also me" self handles ----
 *
 * @generated from message lvdr.v2.inbox.InboxClearTriageLabelRequest
 */
export type InboxClearTriageLabelRequest = Message<"lvdr.v2.inbox.InboxClearTriageLabelRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxClearTriageLabelRequest.
 * Use `create(InboxClearTriageLabelRequestSchema)` to create a new message.
 */
export const InboxClearTriageLabelRequestSchema: GenMessage<InboxClearTriageLabelRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 42);

/**
 * @generated from message lvdr.v2.inbox.InboxClearTriageLabelResponse
 */
export type InboxClearTriageLabelResponse = Message<"lvdr.v2.inbox.InboxClearTriageLabelResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;
};

/**
 * Describes the message lvdr.v2.inbox.InboxClearTriageLabelResponse.
 * Use `create(InboxClearTriageLabelResponseSchema)` to create a new message.
 */
export const InboxClearTriageLabelResponseSchema: GenMessage<InboxClearTriageLabelResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 43);

/**
 * @generated from message lvdr.v2.inbox.InboxListSelfHandlesRequest
 */
export type InboxListSelfHandlesRequest = Message<"lvdr.v2.inbox.InboxListSelfHandlesRequest"> & {
};

/**
 * Describes the message lvdr.v2.inbox.InboxListSelfHandlesRequest.
 * Use `create(InboxListSelfHandlesRequestSchema)` to create a new message.
 */
export const InboxListSelfHandlesRequestSchema: GenMessage<InboxListSelfHandlesRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 44);

/**
 * @generated from message lvdr.v2.inbox.InboxListSelfHandlesResponse
 */
export type InboxListSelfHandlesResponse = Message<"lvdr.v2.inbox.InboxListSelfHandlesResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: repeated lvdr.v2.inbox.Handle handles = 2;
   */
  handles: Handle[];
};

/**
 * Describes the message lvdr.v2.inbox.InboxListSelfHandlesResponse.
 * Use `create(InboxListSelfHandlesResponseSchema)` to create a new message.
 */
export const InboxListSelfHandlesResponseSchema: GenMessage<InboxListSelfHandlesResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 45);

/**
 * Replaces the whole list. At most 50 handles; exact kinds only; EMAIL values are lowercased and trimmed.
 *
 * @generated from message lvdr.v2.inbox.InboxSetSelfHandlesRequest
 */
export type InboxSetSelfHandlesRequest = Message<"lvdr.v2.inbox.InboxSetSelfHandlesRequest"> & {
  /**
   * @generated from field: repeated lvdr.v2.inbox.Handle handles = 1;
   */
  handles: Handle[];
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetSelfHandlesRequest.
 * Use `create(InboxSetSelfHandlesRequestSchema)` to create a new message.
 */
export const InboxSetSelfHandlesRequestSchema: GenMessage<InboxSetSelfHandlesRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 46);

/**
 * @generated from message lvdr.v2.inbox.InboxSetSelfHandlesResponse
 */
export type InboxSetSelfHandlesResponse = Message<"lvdr.v2.inbox.InboxSetSelfHandlesResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: repeated lvdr.v2.inbox.Handle handles = 2;
   */
  handles: Handle[];
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetSelfHandlesResponse.
 * Use `create(InboxSetSelfHandlesResponseSchema)` to create a new message.
 */
export const InboxSetSelfHandlesResponseSchema: GenMessage<InboxSetSelfHandlesResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 47);

/**
 * ---- INBOX-23: accounts and channels in one inbox ----
 * The source a conversation or a mailbox preference names: SourceRef's {adapter, account_ref}. Channel-neutral (D3).
 *
 * @generated from message lvdr.v2.inbox.InboxAccount
 */
export type InboxAccount = Message<"lvdr.v2.inbox.InboxAccount"> & {
  /**
   * @generated from field: string adapter = 1;
   */
  adapter: string;

  /**
   * @generated from field: string account_ref = 2;
   */
  accountRef: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxAccount.
 * Use `create(InboxAccountSchema)` to create a new message.
 */
export const InboxAccountSchema: GenMessage<InboxAccount> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 48);

/**
 * Renames a connected source. label is trimmed; "" clears it; > 40 runes or a control character is INVALID_INPUT;
 * an unknown source is NOT_FOUND. A manage_only user may rename.
 *
 * @generated from message lvdr.v2.inbox.InboxSetMailboxLabelRequest
 */
export type InboxSetMailboxLabelRequest = Message<"lvdr.v2.inbox.InboxSetMailboxLabelRequest"> & {
  /**
   * @generated from field: string adapter = 1;
   */
  adapter: string;

  /**
   * @generated from field: string account_ref = 2;
   */
  accountRef: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetMailboxLabelRequest.
 * Use `create(InboxSetMailboxLabelRequestSchema)` to create a new message.
 */
export const InboxSetMailboxLabelRequestSchema: GenMessage<InboxSetMailboxLabelRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 49);

/**
 * @generated from message lvdr.v2.inbox.InboxSetMailboxLabelResponse
 */
export type InboxSetMailboxLabelResponse = Message<"lvdr.v2.inbox.InboxSetMailboxLabelResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: lvdr.v2.inbox.InboxSource source = 2;
   */
  source?: InboxSource | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetMailboxLabelResponse.
 * Use `create(InboxSetMailboxLabelResponseSchema)` to create a new message.
 */
export const InboxSetMailboxLabelResponseSchema: GenMessage<InboxSetMailboxLabelResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 50);

/**
 * Stores the /inbox mailbox filter. account absent = All; a source that is not connected is NOT_FOUND.
 *
 * @generated from message lvdr.v2.inbox.InboxSetMailboxFilterRequest
 */
export type InboxSetMailboxFilterRequest = Message<"lvdr.v2.inbox.InboxSetMailboxFilterRequest"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxAccount account = 1;
   */
  account?: InboxAccount | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetMailboxFilterRequest.
 * Use `create(InboxSetMailboxFilterRequestSchema)` to create a new message.
 */
export const InboxSetMailboxFilterRequestSchema: GenMessage<InboxSetMailboxFilterRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 51);

/**
 * @generated from message lvdr.v2.inbox.InboxSetMailboxFilterResponse
 */
export type InboxSetMailboxFilterResponse = Message<"lvdr.v2.inbox.InboxSetMailboxFilterResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: lvdr.v2.inbox.InboxAccount account = 2;
   */
  account?: InboxAccount | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetMailboxFilterResponse.
 * Use `create(InboxSetMailboxFilterResponseSchema)` to create a new message.
 */
export const InboxSetMailboxFilterResponseSchema: GenMessage<InboxSetMailboxFilterResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 52);

/**
 * INBOX-06 context card — the person behind a conversation, every item citing an
 * interaction (design docs/plans/2026-10-08-inbox06-context-card-design.md).
 *
 * @generated from message lvdr.v2.inbox.CardCite
 */
export type CardCite = Message<"lvdr.v2.inbox.CardCite"> & {
  /**
   * @generated from field: string interaction_id = 1;
   */
  interactionId: string;

  /**
   * @generated from field: google.protobuf.Timestamp at = 2;
   */
  at?: Timestamp | undefined;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;
};

/**
 * Describes the message lvdr.v2.inbox.CardCite.
 * Use `create(CardCiteSchema)` to create a new message.
 */
export const CardCiteSchema: GenMessage<CardCite> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 53);

/**
 * @generated from message lvdr.v2.inbox.CardContact
 */
export type CardContact = Message<"lvdr.v2.inbox.CardContact"> & {
  /**
   * @generated from field: string contact_id = 1;
   */
  contactId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: repeated lvdr.v2.inbox.Handle handles = 3;
   */
  handles: Handle[];

  /**
   * @generated from field: bool primary = 4;
   */
  primary: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.CardContact.
 * Use `create(CardContactSchema)` to create a new message.
 */
export const CardContactSchema: GenMessage<CardContact> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 54);

/**
 * @generated from message lvdr.v2.inbox.CardFact
 */
export type CardFact = Message<"lvdr.v2.inbox.CardFact"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * @generated from field: repeated lvdr.v2.inbox.CardCite cites = 3;
   */
  cites: CardCite[];

  /**
   * @generated from field: int32 cite_total = 4;
   */
  citeTotal: number;
};

/**
 * Describes the message lvdr.v2.inbox.CardFact.
 * Use `create(CardFactSchema)` to create a new message.
 */
export const CardFactSchema: GenMessage<CardFact> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 55);

/**
 * @generated from message lvdr.v2.inbox.CardStat
 */
export type CardStat = Message<"lvdr.v2.inbox.CardStat"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: int32 count_30d = 2;
   */
  count30d: number;

  /**
   * @generated from field: int32 count_90d = 3;
   */
  count90d: number;

  /**
   * @generated from field: optional int64 their_median_reply_sec = 4;
   */
  theirMedianReplySec?: bigint | undefined;

  /**
   * absent = fewer than 3 samples
   *
   * @generated from field: optional int64 your_median_reply_sec = 5;
   */
  yourMedianReplySec?: bigint | undefined;

  /**
   * @generated from field: int32 their_samples = 6;
   */
  theirSamples: number;

  /**
   * @generated from field: int32 your_samples = 7;
   */
  yourSamples: number;

  /**
   * @generated from field: repeated lvdr.v2.inbox.CardCite cites = 8;
   */
  cites: CardCite[];

  /**
   * @generated from field: int32 cite_total = 9;
   */
  citeTotal: number;
};

/**
 * Describes the message lvdr.v2.inbox.CardStat.
 * Use `create(CardStatSchema)` to create a new message.
 */
export const CardStatSchema: GenMessage<CardStat> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 56);

/**
 * @generated from message lvdr.v2.inbox.CardLoop
 */
export type CardLoop = Message<"lvdr.v2.inbox.CardLoop"> & {
  /**
   * @generated from field: string item_key = 1;
   */
  itemKey: string;

  /**
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: lvdr.v2.inbox.CardCite cite = 3;
   */
  cite?: CardCite | undefined;

  /**
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string dir = 5;
   */
  dir: string;

  /**
   * @generated from field: string title = 6;
   */
  title: string;

  /**
   * @generated from field: google.protobuf.Timestamp due = 7;
   */
  due?: Timestamp | undefined;

  /**
   * @generated from field: string task_id = 8;
   */
  taskId: string;

  /**
   * @generated from field: string task_status = 9;
   */
  taskStatus: string;

  /**
   * @generated from field: bool dismissable = 10;
   */
  dismissable: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.CardLoop.
 * Use `create(CardLoopSchema)` to create a new message.
 */
export const CardLoopSchema: GenMessage<CardLoop> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 57);

/**
 * @generated from message lvdr.v2.inbox.CardChange
 */
export type CardChange = Message<"lvdr.v2.inbox.CardChange"> & {
  /**
   * @generated from field: lvdr.v2.inbox.CardCite cite = 1;
   */
  cite?: CardCite | undefined;

  /**
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: string direction = 3;
   */
  direction: string;

  /**
   * @generated from field: string subject = 4;
   */
  subject: string;

  /**
   * @generated from field: bool blocked = 5;
   */
  blocked: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.CardChange.
 * Use `create(CardChangeSchema)` to create a new message.
 */
export const CardChangeSchema: GenMessage<CardChange> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 58);

/**
 * @generated from message lvdr.v2.inbox.CardWarning
 */
export type CardWarning = Message<"lvdr.v2.inbox.CardWarning"> & {
  /**
   * @generated from field: lvdr.v2.inbox.CardCite cite = 1;
   */
  cite?: CardCite | undefined;

  /**
   * @generated from field: repeated string codes = 2;
   */
  codes: string[];

  /**
   * @generated from field: repeated string risk_phrases = 3;
   */
  riskPhrases: string[];
};

/**
 * Describes the message lvdr.v2.inbox.CardWarning.
 * Use `create(CardWarningSchema)` to create a new message.
 */
export const CardWarningSchema: GenMessage<CardWarning> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 59);

/**
 * @generated from message lvdr.v2.inbox.CardRuleTerm
 */
export type CardRuleTerm = Message<"lvdr.v2.inbox.CardRuleTerm"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message lvdr.v2.inbox.CardRuleTerm.
 * Use `create(CardRuleTermSchema)` to create a new message.
 */
export const CardRuleTermSchema: GenMessage<CardRuleTerm> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 60);

/**
 * @generated from message lvdr.v2.inbox.CardWhy
 */
export type CardWhy = Message<"lvdr.v2.inbox.CardWhy"> & {
  /**
   * @generated from field: lvdr.v2.inbox.TriageBucket bucket = 1;
   */
  bucket: TriageBucket;

  /**
   * @generated from field: int32 rule_index = 2;
   */
  ruleIndex: number;

  /**
   * @generated from field: repeated lvdr.v2.inbox.CardRuleTerm terms = 3;
   */
  terms: CardRuleTerm[];
};

/**
 * Describes the message lvdr.v2.inbox.CardWhy.
 * Use `create(CardWhySchema)` to create a new message.
 */
export const CardWhySchema: GenMessage<CardWhy> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 61);

/**
 * @generated from message lvdr.v2.inbox.ContextCard
 */
export type ContextCard = Message<"lvdr.v2.inbox.ContextCard"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string subject = 3;
   */
  subject: string;

  /**
   * @generated from field: repeated lvdr.v2.inbox.CardContact participants = 4;
   */
  participants: CardContact[];

  /**
   * @generated from field: string selected_contact_id = 5;
   */
  selectedContactId: string;

  /**
   * @generated from field: repeated lvdr.v2.inbox.CardFact facts = 6;
   */
  facts: CardFact[];

  /**
   * @generated from field: repeated lvdr.v2.inbox.CardStat stats = 7;
   */
  stats: CardStat[];

  /**
   * @generated from field: repeated lvdr.v2.inbox.CardLoop you_owe = 8;
   */
  youOwe: CardLoop[];

  /**
   * @generated from field: repeated lvdr.v2.inbox.CardLoop they_owe = 9;
   */
  theyOwe: CardLoop[];

  /**
   * unset = you have not replied
   *
   * @generated from field: lvdr.v2.inbox.CardCite last_reply = 10;
   */
  lastReply?: CardCite | undefined;

  /**
   * @generated from field: repeated lvdr.v2.inbox.CardChange changed = 11;
   */
  changed: CardChange[];

  /**
   * @generated from field: repeated lvdr.v2.inbox.CardWarning warnings = 12;
   */
  warnings: CardWarning[];

  /**
   * unset when inbox_triage is off or the conversation has no bucket
   *
   * @generated from field: lvdr.v2.inbox.CardWhy why = 13;
   */
  why?: CardWhy | undefined;

  /**
   * @generated from field: bool identity_degraded = 14;
   */
  identityDegraded: boolean;

  /**
   * @generated from field: bool tasks_degraded = 15;
   */
  tasksDegraded: boolean;

  /**
   * @generated from field: bool rows_capped = 16;
   */
  rowsCapped: boolean;

  /**
   * @generated from field: bool participants_capped = 17;
   */
  participantsCapped: boolean;

  /**
   * INBOX-20b: every handle on every row is self; false while identity is degraded
   *
   * @generated from field: bool self_only = 18;
   */
  selfOnly: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.ContextCard.
 * Use `create(ContextCardSchema)` to create a new message.
 */
export const ContextCardSchema: GenMessage<ContextCard> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 62);

/**
 * @generated from message lvdr.v2.inbox.InteractionText
 */
export type InteractionText = Message<"lvdr.v2.inbox.InteractionText"> & {
  /**
   * @generated from field: string interaction_id = 1;
   */
  interactionId: string;

  /**
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string direction = 4;
   */
  direction: string;

  /**
   * @generated from field: google.protobuf.Timestamp at = 5;
   */
  at?: Timestamp | undefined;

  /**
   * @generated from field: string subject = 6;
   */
  subject: string;

  /**
   * @generated from field: string body = 7;
   */
  body: string;

  /**
   * @generated from field: bool truncated = 8;
   */
  truncated: boolean;

  /**
   * @generated from field: bool withheld = 9;
   */
  withheld: boolean;

  /**
   * LIMIT-32: the adapter's import cuts, kept when withheld
   *
   * @generated from field: repeated lvdr.v2.errors.LimitCut import_cuts = 10;
   */
  importCuts: LimitCut[];

  /**
   * LIMIT-32: set only on a push drain's drop notice
   *
   * @generated from field: lvdr.v2.inbox.IntakeDropNotice drop_notice = 11;
   */
  dropNotice?: IntakeDropNotice | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InteractionText.
 * Use `create(InteractionTextSchema)` to create a new message.
 */
export const InteractionTextSchema: GenMessage<InteractionText> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 63);

/**
 * @generated from message lvdr.v2.inbox.InboxGetContextCardRequest
 */
export type InboxGetContextCardRequest = Message<"lvdr.v2.inbox.InboxGetContextCardRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string contact_id = 2;
   */
  contactId: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetContextCardRequest.
 * Use `create(InboxGetContextCardRequestSchema)` to create a new message.
 */
export const InboxGetContextCardRequestSchema: GenMessage<InboxGetContextCardRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 64);

/**
 * @generated from message lvdr.v2.inbox.InboxGetContextCardResponse
 */
export type InboxGetContextCardResponse = Message<"lvdr.v2.inbox.InboxGetContextCardResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: lvdr.v2.inbox.ContextCard card = 2;
   */
  card?: ContextCard | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetContextCardResponse.
 * Use `create(InboxGetContextCardResponseSchema)` to create a new message.
 */
export const InboxGetContextCardResponseSchema: GenMessage<InboxGetContextCardResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 65);

/**
 * @generated from message lvdr.v2.inbox.InboxGetInteractionTextRequest
 */
export type InboxGetInteractionTextRequest = Message<"lvdr.v2.inbox.InboxGetInteractionTextRequest"> & {
  /**
   * @generated from field: string interaction_id = 1;
   */
  interactionId: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetInteractionTextRequest.
 * Use `create(InboxGetInteractionTextRequestSchema)` to create a new message.
 */
export const InboxGetInteractionTextRequestSchema: GenMessage<InboxGetInteractionTextRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 66);

/**
 * @generated from message lvdr.v2.inbox.InboxGetInteractionTextResponse
 */
export type InboxGetInteractionTextResponse = Message<"lvdr.v2.inbox.InboxGetInteractionTextResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: lvdr.v2.inbox.InteractionText text = 2;
   */
  text?: InteractionText | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetInteractionTextResponse.
 * Use `create(InboxGetInteractionTextResponseSchema)` to create a new message.
 */
export const InboxGetInteractionTextResponseSchema: GenMessage<InboxGetInteractionTextResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 67);

/**
 * @generated from message lvdr.v2.inbox.InboxSetLoopDismissedRequest
 */
export type InboxSetLoopDismissedRequest = Message<"lvdr.v2.inbox.InboxSetLoopDismissedRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string item_key = 2;
   */
  itemKey: string;

  /**
   * @generated from field: bool dismissed = 3;
   */
  dismissed: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetLoopDismissedRequest.
 * Use `create(InboxSetLoopDismissedRequestSchema)` to create a new message.
 */
export const InboxSetLoopDismissedRequestSchema: GenMessage<InboxSetLoopDismissedRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 68);

/**
 * @generated from message lvdr.v2.inbox.InboxSetLoopDismissedResponse
 */
export type InboxSetLoopDismissedResponse = Message<"lvdr.v2.inbox.InboxSetLoopDismissedResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetLoopDismissedResponse.
 * Use `create(InboxSetLoopDismissedResponseSchema)` to create a new message.
 */
export const InboxSetLoopDismissedResponseSchema: GenMessage<InboxSetLoopDismissedResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 69);

/**
 * ---- INBOX-21: conversation thread ----
 * One item of a conversation, body-free: snippet is the first non-blank line of ixtext's capped
 * authored text (<= 140 B), "" when withheld or gone. subject is the capped Row subject (<= 120 B).
 * from is the first sender handle (from | author | speaker); unset when none.
 *
 * @generated from message lvdr.v2.inbox.ThreadItem
 */
export type ThreadItem = Message<"lvdr.v2.inbox.ThreadItem"> & {
  /**
   * @generated from field: string interaction_id = 1;
   */
  interactionId: string;

  /**
   * @generated from field: google.protobuf.Timestamp at = 2;
   */
  at?: Timestamp | undefined;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string direction = 4;
   */
  direction: string;

  /**
   * @generated from field: string subject = 5;
   */
  subject: string;

  /**
   * @generated from field: lvdr.v2.inbox.Handle from = 6;
   */
  from?: Handle | undefined;

  /**
   * @generated from field: bool self = 7;
   */
  self: boolean;

  /**
   * @generated from field: string snippet = 8;
   */
  snippet: string;

  /**
   * @generated from field: bool withheld = 9;
   */
  withheld: boolean;

  /**
   * @generated from field: bool gone = 10;
   */
  gone: boolean;

  /**
   * @generated from field: string deep_link = 11;
   */
  deepLink: string;

  /**
   * @generated from field: repeated string duplicate_ids = 12;
   */
  duplicateIds: string[];
};

/**
 * Describes the message lvdr.v2.inbox.ThreadItem.
 * Use `create(ThreadItemSchema)` to create a new message.
 */
export const ThreadItemSchema: GenMessage<ThreadItem> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 70);

/**
 * @generated from message lvdr.v2.inbox.InboxGetConversationRequest
 */
export type InboxGetConversationRequest = Message<"lvdr.v2.inbox.InboxGetConversationRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetConversationRequest.
 * Use `create(InboxGetConversationRequestSchema)` to create a new message.
 */
export const InboxGetConversationRequestSchema: GenMessage<InboxGetConversationRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 71);

/**
 * items: the newest 50 after the Inbox/Sent dedupe, oldest first; capped = more existed. bucket is
 * UNSPECIFIED for a CALL, an untriaged conversation, or while inbox_triage is off.
 *
 * @generated from message lvdr.v2.inbox.InboxGetConversationResponse
 */
export type InboxGetConversationResponse = Message<"lvdr.v2.inbox.InboxGetConversationResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: lvdr.v2.inbox.TriageBucket bucket = 4;
   */
  bucket: TriageBucket;

  /**
   * @generated from field: string subject = 5;
   */
  subject: string;

  /**
   * @generated from field: repeated lvdr.v2.inbox.ThreadItem items = 6;
   */
  items: ThreadItem[];

  /**
   * @generated from field: bool capped = 7;
   */
  capped: boolean;

  /**
   * @generated from field: lvdr.v2.inbox.InboxAccount account = 8;
   */
  account?: InboxAccount | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetConversationResponse.
 * Use `create(InboxGetConversationResponseSchema)` to create a new message.
 */
export const InboxGetConversationResponseSchema: GenMessage<InboxGetConversationResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 72);

/**
 * @generated from message lvdr.v2.inbox.StyleField
 */
export type StyleField = Message<"lvdr.v2.inbox.StyleField"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;
};

/**
 * Describes the message lvdr.v2.inbox.StyleField.
 * Use `create(StyleFieldSchema)` to create a new message.
 */
export const StyleFieldSchema: GenMessage<StyleField> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 73);

/**
 * @generated from message lvdr.v2.inbox.StyleCard
 */
export type StyleCard = Message<"lvdr.v2.inbox.StyleCard"> & {
  /**
   * @generated from field: string contact_id = 1;
   */
  contactId: string;

  /**
   * @generated from field: lvdr.v2.inbox.StyleField language = 2;
   */
  language?: StyleField | undefined;

  /**
   * @generated from field: lvdr.v2.inbox.StyleField register = 3;
   */
  register?: StyleField | undefined;

  /**
   * @generated from field: lvdr.v2.inbox.StyleField greeting = 4;
   */
  greeting?: StyleField | undefined;

  /**
   * @generated from field: lvdr.v2.inbox.StyleField sign_off = 5;
   */
  signOff?: StyleField | undefined;

  /**
   * @generated from field: int32 length_words = 6;
   */
  lengthWords: number;

  /**
   * @generated from field: string length_source = 7;
   */
  lengthSource: string;

  /**
   * @generated from field: int32 sample_count = 8;
   */
  sampleCount: number;

  /**
   * contact | global — the lvdr_inbox_drafts_appended_total label (D18)
   *
   * @generated from field: string style_source = 9;
   */
  styleSource: string;
};

/**
 * Describes the message lvdr.v2.inbox.StyleCard.
 * Use `create(StyleCardSchema)` to create a new message.
 */
export const StyleCardSchema: GenMessage<StyleCard> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 74);

/**
 * @generated from message lvdr.v2.inbox.DraftAsk
 */
export type DraftAsk = Message<"lvdr.v2.inbox.DraftAsk"> & {
  /**
   * @generated from field: string interaction_id = 1;
   */
  interactionId: string;

  /**
   * @generated from field: string item_key = 2;
   */
  itemKey: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string outcome = 4;
   */
  outcome: string;
};

/**
 * Describes the message lvdr.v2.inbox.DraftAsk.
 * Use `create(DraftAskSchema)` to create a new message.
 */
export const DraftAskSchema: GenMessage<DraftAsk> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 75);

/**
 * @generated from message lvdr.v2.inbox.InboxDraftReplyRequest
 */
export type InboxDraftReplyRequest = Message<"lvdr.v2.inbox.InboxDraftReplyRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxDraftReplyRequest.
 * Use `create(InboxDraftReplyRequestSchema)` to create a new message.
 */
export const InboxDraftReplyRequestSchema: GenMessage<InboxDraftReplyRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 76);

/**
 * @generated from message lvdr.v2.inbox.InboxDraftReplyResponse
 */
export type InboxDraftReplyResponse = Message<"lvdr.v2.inbox.InboxDraftReplyResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: string body = 2;
   */
  body: string;

  /**
   * @generated from field: repeated lvdr.v2.inbox.CardCite citations = 3;
   */
  citations: CardCite[];

  /**
   * @generated from field: repeated lvdr.v2.inbox.DraftAsk asks = 4;
   */
  asks: DraftAsk[];

  /**
   * @generated from field: lvdr.v2.inbox.StyleCard style = 5;
   */
  style?: StyleCard | undefined;

  /**
   * @generated from field: string style_source = 6;
   */
  styleSource: string;

  /**
   * warning unset = no Go warning on the target
   *
   * @generated from field: lvdr.v2.inbox.CardWarning warning = 7;
   */
  warning?: CardWarning | undefined;

  /**
   * false = the server has no UIDPLUS: an older LVDR draft stays beside the new one (D11)
   *
   * @generated from field: bool replaces_previous = 8;
   */
  replacesPrevious: boolean;

  /**
   * a refinement of error_code for draft copy: no_drafts_folder | original_gone | trust_floor | send_gate | ""
   *
   * @generated from field: string reason = 9;
   */
  reason: string;

  /**
   * @generated from field: lvdr.v2.common.AiMark ai_mark = 10;
   */
  aiMark?: AiMark | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxDraftReplyResponse.
 * Use `create(InboxDraftReplyResponseSchema)` to create a new message.
 */
export const InboxDraftReplyResponseSchema: GenMessage<InboxDraftReplyResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 77);

/**
 * @generated from message lvdr.v2.inbox.InboxGetDraftContextRequest
 */
export type InboxGetDraftContextRequest = Message<"lvdr.v2.inbox.InboxGetDraftContextRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetDraftContextRequest.
 * Use `create(InboxGetDraftContextRequestSchema)` to create a new message.
 */
export const InboxGetDraftContextRequestSchema: GenMessage<InboxGetDraftContextRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 78);

/**
 * @generated from message lvdr.v2.inbox.InboxGetDraftContextResponse
 */
export type InboxGetDraftContextResponse = Message<"lvdr.v2.inbox.InboxGetDraftContextResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: lvdr.v2.inbox.DraftContextState state = 2;
   */
  state: DraftContextState;

  /**
   * @generated from field: string contact_id = 3;
   */
  contactId: string;

  /**
   * @generated from field: lvdr.v2.inbox.StyleCard style = 4;
   */
  style?: StyleCard | undefined;

  /**
   * @generated from field: int32 sample_count = 5;
   */
  sampleCount: number;

  /**
   * @generated from field: lvdr.v2.inbox.InboxAccount account = 6;
   */
  account?: InboxAccount | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetDraftContextResponse.
 * Use `create(InboxGetDraftContextResponseSchema)` to create a new message.
 */
export const InboxGetDraftContextResponseSchema: GenMessage<InboxGetDraftContextResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 79);

/**
 * @generated from message lvdr.v2.inbox.InboxSetStyleOverrideRequest
 */
export type InboxSetStyleOverrideRequest = Message<"lvdr.v2.inbox.InboxSetStyleOverrideRequest"> & {
  /**
   * @generated from field: string contact_id = 1;
   */
  contactId: string;

  /**
   * @generated from field: string language = 2;
   */
  language: string;

  /**
   * @generated from field: string register = 3;
   */
  register: string;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetStyleOverrideRequest.
 * Use `create(InboxSetStyleOverrideRequestSchema)` to create a new message.
 */
export const InboxSetStyleOverrideRequestSchema: GenMessage<InboxSetStyleOverrideRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 80);

/**
 * @generated from message lvdr.v2.inbox.InboxSetStyleOverrideResponse
 */
export type InboxSetStyleOverrideResponse = Message<"lvdr.v2.inbox.InboxSetStyleOverrideResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: lvdr.v2.inbox.StyleCard style = 2;
   */
  style?: StyleCard | undefined;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetStyleOverrideResponse.
 * Use `create(InboxSetStyleOverrideResponseSchema)` to create a new message.
 */
export const InboxSetStyleOverrideResponseSchema: GenMessage<InboxSetStyleOverrideResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 81);

/**
 * ---- INBOX-22: triage rules view ----
 * ConvCondition mirrors rules.ConvCondition field for field. A list is present when non-empty, a string when
 * non-empty, an optional bool when set; every present field is AND-ed, list fields are any-of.
 *
 * @generated from message lvdr.v2.inbox.ConvCondition
 */
export type ConvCondition = Message<"lvdr.v2.inbox.ConvCondition"> & {
  /**
   * contact ids
   *
   * @generated from field: repeated string contacts = 1;
   */
  contacts: string[];

  /**
   * matched case-insensitively
   *
   * @generated from field: repeated string domains = 2;
   */
  domains: string[];

  /**
   * "" | email | chat
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * "" | in | out
   *
   * @generated from field: string last_direction = 4;
   */
  lastDirection: string;

  /**
   * "" | to | cc | none
   *
   * @generated from field: string addressed = 5;
   */
  addressed: string;

  /**
   * @generated from field: optional bool has_ask = 6;
   */
  hasAsk?: boolean | undefined;

  /**
   * @generated from field: optional bool has_deadline = 7;
   */
  hasDeadline?: boolean | undefined;

  /**
   * automated | list | self
   *
   * @generated from field: repeated string noise = 8;
   */
  noise: string[];
};

/**
 * Describes the message lvdr.v2.inbox.ConvCondition.
 * Use `create(ConvConditionSchema)` to create a new message.
 */
export const ConvConditionSchema: GenMessage<ConvCondition> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 82);

/**
 * ConvRule is rules.ConvRule: a conditional route (condition + bucket) or, when otherwise is set, the terminal
 * rule that matches every conversation no earlier rule matched (rules.ConvRule.Default). Exactly the last rule
 * of a set has otherwise = true. Named condition/otherwise (not if/default) because they read better in Go and
 * TS (GetOtherwise over GetDefault); protobuf-es would generate if/default fine.
 *
 * @generated from message lvdr.v2.inbox.ConvRule
 */
export type ConvRule = Message<"lvdr.v2.inbox.ConvRule"> & {
  /**
   * unset when otherwise
   *
   * @generated from field: lvdr.v2.inbox.ConvCondition condition = 1;
   */
  condition?: ConvCondition | undefined;

  /**
   * @generated from field: lvdr.v2.inbox.TriageBucket bucket = 2;
   */
  bucket: TriageBucket;

  /**
   * @generated from field: bool otherwise = 3;
   */
  otherwise: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.ConvRule.
 * Use `create(ConvRuleSchema)` to create a new message.
 */
export const ConvRuleSchema: GenMessage<ConvRule> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 83);

/**
 * @generated from message lvdr.v2.inbox.ConvRuleList
 */
export type ConvRuleList = Message<"lvdr.v2.inbox.ConvRuleList"> & {
  /**
   * @generated from field: repeated lvdr.v2.inbox.ConvRule rules = 1;
   */
  rules: ConvRule[];
};

/**
 * Describes the message lvdr.v2.inbox.ConvRuleList.
 * Use `create(ConvRuleListSchema)` to create a new message.
 */
export const ConvRuleListSchema: GenMessage<ConvRuleList> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 84);

/**
 * @generated from message lvdr.v2.inbox.ContactOption
 */
export type ContactOption = Message<"lvdr.v2.inbox.ContactOption"> & {
  /**
   * @generated from field: string contact_id = 1;
   */
  contactId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message lvdr.v2.inbox.ContactOption.
 * Use `create(ContactOptionSchema)` to create a new message.
 */
export const ContactOptionSchema: GenMessage<ContactOption> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 85);

/**
 * @generated from message lvdr.v2.inbox.PendingRuleProposal
 */
export type PendingRuleProposal = Message<"lvdr.v2.inbox.PendingRuleProposal"> & {
  /**
   * @generated from field: string contact_id = 1;
   */
  contactId: string;

  /**
   * "" = not resolved
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * the bucket the user labelled into
   *
   * @generated from field: lvdr.v2.inbox.TriageBucket bucket = 3;
   */
  bucket: TriageBucket;

  /**
   * labelled conversations of this contact still outside that bucket
   *
   * @generated from field: int32 conversation_count = 4;
   */
  conversationCount: number;

  /**
   * the newest of them: InboxConfirmRuleProposalRequest's conversation_id
   *
   * @generated from field: string conversation_id = 5;
   */
  conversationId: string;
};

/**
 * Describes the message lvdr.v2.inbox.PendingRuleProposal.
 * Use `create(PendingRuleProposalSchema)` to create a new message.
 */
export const PendingRuleProposalSchema: GenMessage<PendingRuleProposal> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 86);

/**
 * @generated from message lvdr.v2.inbox.InboxGetConvRulesRequest
 */
export type InboxGetConvRulesRequest = Message<"lvdr.v2.inbox.InboxGetConvRulesRequest"> & {
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetConvRulesRequest.
 * Use `create(InboxGetConvRulesRequestSchema)` to create a new message.
 */
export const InboxGetConvRulesRequestSchema: GenMessage<InboxGetConvRulesRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 87);

/**
 * @generated from message lvdr.v2.inbox.InboxGetConvRulesResponse
 */
export type InboxGetConvRulesResponse = Message<"lvdr.v2.inbox.InboxGetConvRulesResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * the effective set (defaults when origin is default or unreadable)
   *
   * @generated from field: repeated lvdr.v2.inbox.ConvRule rules = 2;
   */
  rules: ConvRule[];

  /**
   * the CAS token every Set must echo
   *
   * @generated from field: string fingerprint = 3;
   */
  fingerprint: string;

  /**
   * conversations half: user | default | unreadable
   *
   * @generated from field: string origin = 4;
   */
  origin: string;

  /**
   * per rule: structurally equal to a rule of the code defaults (D12)
   *
   * @generated from field: repeated bool is_default = 5;
   */
  isDefault: boolean[];

  /**
   * per rule; meaningful only when counts_known
   *
   * @generated from field: repeated int32 match_counts = 6;
   */
  matchCounts: number[];

  /**
   * false = identity busy or the 2 s budget ran out; never send zeros for unknown
   *
   * @generated from field: bool counts_known = 7;
   */
  countsKnown: boolean;

  /**
   * @generated from field: repeated lvdr.v2.inbox.PendingRuleProposal proposals = 8;
   */
  proposals: PendingRuleProposal[];

  /**
   * D32: most recent first, at most 500
   *
   * @generated from field: repeated lvdr.v2.inbox.ContactOption contact_options = 9;
   */
  contactOptions: ContactOption[];

  /**
   * rule contact id → display name
   *
   * @generated from field: map<string, string> contact_names = 10;
   */
  contactNames: { [key: string]: string };

  /**
   * either stored half is unreadable: only Set{recover} is accepted
   *
   * @generated from field: bool unreadable = 11;
   */
  unreadable: boolean;

  /**
   * @generated from field: bool undo_available = 12;
   */
  undoAvailable: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.InboxGetConvRulesResponse.
 * Use `create(InboxGetConvRulesResponseSchema)` to create a new message.
 */
export const InboxGetConvRulesResponseSchema: GenMessage<InboxGetConvRulesResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 88);

/**
 * @generated from message lvdr.v2.inbox.InboxPreviewConvRulesRequest
 */
export type InboxPreviewConvRulesRequest = Message<"lvdr.v2.inbox.InboxPreviewConvRulesRequest"> & {
  /**
   * @generated from field: repeated lvdr.v2.inbox.ConvRule rules = 1;
   */
  rules: ConvRule[];
};

/**
 * Describes the message lvdr.v2.inbox.InboxPreviewConvRulesRequest.
 * Use `create(InboxPreviewConvRulesRequestSchema)` to create a new message.
 */
export const InboxPreviewConvRulesRequestSchema: GenMessage<InboxPreviewConvRulesRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 89);

/**
 * @generated from message lvdr.v2.inbox.InboxPreviewConvRulesResponse
 */
export type InboxPreviewConvRulesResponse = Message<"lvdr.v2.inbox.InboxPreviewConvRulesResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: bool counts_known = 2;
   */
  countsKnown: boolean;

  /**
   * conversations whose bucket the candidate changes; meaningful only when counts_known
   *
   * @generated from field: int32 moved = 3;
   */
  moved: number;

  /**
   * per candidate rule; meaningful only when counts_known
   *
   * @generated from field: repeated int32 per_rule = 4;
   */
  perRule: number[];

  /**
   * NEEDS_ME|WAITING|FYI|NOISE → count under the candidate; only when counts_known
   *
   * @generated from field: map<string, int32> per_bucket = 5;
   */
  perBucket: { [key: string]: number };

  /**
   * D38: the candidate's domains that are public mail providers; always computed
   *
   * @generated from field: repeated string public_domains = 6;
   */
  publicDomains: string[];
};

/**
 * Describes the message lvdr.v2.inbox.InboxPreviewConvRulesResponse.
 * Use `create(InboxPreviewConvRulesResponseSchema)` to create a new message.
 */
export const InboxPreviewConvRulesResponseSchema: GenMessage<InboxPreviewConvRulesResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 90);

/**
 * @generated from message lvdr.v2.inbox.InboxSetConvRulesRequest
 */
export type InboxSetConvRulesRequest = Message<"lvdr.v2.inbox.InboxSetConvRulesRequest"> & {
  /**
   * required: the fingerprint of the set the client read
   *
   * @generated from field: string expect_fingerprint = 1;
   */
  expectFingerprint: string;

  /**
   * @generated from oneof lvdr.v2.inbox.InboxSetConvRulesRequest.change
   */
  change: {
    /**
     * replace the whole set
     *
     * @generated from field: lvdr.v2.inbox.ConvRuleList rules = 2;
     */
    value: ConvRuleList;
    case: "rules";
  } | {
    /**
     * write a null half: the user follows future default changes (D12)
     *
     * @generated from field: bool reset_to_defaults = 3;
     */
    value: boolean;
    case: "resetToDefaults";
  } | {
    /**
     * restore rules/prev; Undo of an Undo is a redo (D11)
     *
     * @generated from field: bool undo = 4;
     */
    value: boolean;
    case: "undo";
  } | {
    /**
     * only while unreadable: copy the raw record aside, null each unreadable half (D2)
     *
     * @generated from field: bool recover = 5;
     */
    value: boolean;
    case: "recover";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetConvRulesRequest.
 * Use `create(InboxSetConvRulesRequestSchema)` to create a new message.
 */
export const InboxSetConvRulesRequestSchema: GenMessage<InboxSetConvRulesRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 91);

/**
 * @generated from message lvdr.v2.inbox.InboxSetConvRulesResponse
 */
export type InboxSetConvRulesResponse = Message<"lvdr.v2.inbox.InboxSetConvRulesResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;

  /**
   * @generated from field: string fingerprint = 2;
   */
  fingerprint: string;

  /**
   * @generated from field: repeated lvdr.v2.inbox.ConvRule rules = 3;
   */
  rules: ConvRule[];

  /**
   * saved; sorting updates on the next pass
   *
   * @generated from field: bool retriage_deferred = 4;
   */
  retriageDeferred: boolean;

  /**
   * @generated from field: bool undo_available = 5;
   */
  undoAvailable: boolean;
};

/**
 * Describes the message lvdr.v2.inbox.InboxSetConvRulesResponse.
 * Use `create(InboxSetConvRulesResponseSchema)` to create a new message.
 */
export const InboxSetConvRulesResponseSchema: GenMessage<InboxSetConvRulesResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 92);

/**
 * @generated from message lvdr.v2.inbox.InboxDismissRuleProposalRequest
 */
export type InboxDismissRuleProposalRequest = Message<"lvdr.v2.inbox.InboxDismissRuleProposalRequest"> & {
  /**
   * @generated from field: string contact_id = 1;
   */
  contactId: string;

  /**
   * @generated from field: lvdr.v2.inbox.TriageBucket bucket = 2;
   */
  bucket: TriageBucket;
};

/**
 * Describes the message lvdr.v2.inbox.InboxDismissRuleProposalRequest.
 * Use `create(InboxDismissRuleProposalRequestSchema)` to create a new message.
 */
export const InboxDismissRuleProposalRequestSchema: GenMessage<InboxDismissRuleProposalRequest> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 93);

/**
 * @generated from message lvdr.v2.inbox.InboxDismissRuleProposalResponse
 */
export type InboxDismissRuleProposalResponse = Message<"lvdr.v2.inbox.InboxDismissRuleProposalResponse"> & {
  /**
   * @generated from field: lvdr.v2.inbox.InboxErrorCode error_code = 1;
   */
  errorCode: InboxErrorCode;
};

/**
 * Describes the message lvdr.v2.inbox.InboxDismissRuleProposalResponse.
 * Use `create(InboxDismissRuleProposalResponseSchema)` to create a new message.
 */
export const InboxDismissRuleProposalResponseSchema: GenMessage<InboxDismissRuleProposalResponse> = /*@__PURE__*/
  messageDesc(file_inbox_inbox, 94);

/**
 * What kind of source item this is.
 *
 * @generated from enum lvdr.v2.inbox.Kind
 */
export enum Kind {
  /**
   * @generated from enum value: KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: KIND_EMAIL = 1;
   */
  EMAIL = 1,

  /**
   * @generated from enum value: KIND_CHAT = 2;
   */
  CHAT = 2,

  /**
   * @generated from enum value: KIND_CALL = 3;
   */
  CALL = 3,

  /**
   * @generated from enum value: KIND_MEETING = 4;
   */
  MEETING = 4,

  /**
   * @generated from enum value: KIND_DOCUMENT = 5;
   */
  DOCUMENT = 5,
}

/**
 * Describes the enum lvdr.v2.inbox.Kind.
 */
export const KindSchema: GenEnum<Kind> = /*@__PURE__*/
  enumDesc(file_inbox_inbox, 0);

/**
 * Direction relative to the user who owns the log.
 *
 * @generated from enum lvdr.v2.inbox.Direction
 */
export enum Direction {
  /**
   * @generated from enum value: DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTION_IN = 1;
   */
  IN = 1,

  /**
   * @generated from enum value: DIRECTION_OUT = 2;
   */
  OUT = 2,

  /**
   * @generated from enum value: DIRECTION_INTERNAL = 3;
   */
  INTERNAL = 3,

  /**
   * @generated from enum value: DIRECTION_SELF_NOTE = 4;
   */
  SELF_NOTE = 4,
}

/**
 * Describes the enum lvdr.v2.inbox.Direction.
 */
export const DirectionSchema: GenEnum<Direction> = /*@__PURE__*/
  enumDesc(file_inbox_inbox, 1);

/**
 * @generated from enum lvdr.v2.inbox.HandleKind
 */
export enum HandleKind {
  /**
   * @generated from enum value: HANDLE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: HANDLE_KIND_EMAIL = 1;
   */
  EMAIL = 1,

  /**
   * @generated from enum value: HANDLE_KIND_SLACK_USER = 2;
   */
  SLACK_USER = 2,

  /**
   * @generated from enum value: HANDLE_KIND_TEAMS_UPN = 3;
   */
  TEAMS_UPN = 3,

  /**
   * @generated from enum value: HANDLE_KIND_PHONE = 4;
   */
  PHONE = 4,

  /**
   * @generated from enum value: HANDLE_KIND_DISPLAY_NAME = 5;
   */
  DISPLAY_NAME = 5,

  /**
   * @generated from enum value: HANDLE_KIND_SPEAKER_LABEL = 6;
   */
  SPEAKER_LABEL = 6,

  /**
   * INBOX-13a: a Telegram user id in decimal; exact evidence
   *
   * @generated from enum value: HANDLE_KIND_TELEGRAM_USER = 7;
   */
  TELEGRAM_USER = 7,
}

/**
 * Describes the enum lvdr.v2.inbox.HandleKind.
 */
export const HandleKindSchema: GenEnum<HandleKind> = /*@__PURE__*/
  enumDesc(file_inbox_inbox, 2);

/**
 * @generated from enum lvdr.v2.inbox.Role
 */
export enum Role {
  /**
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROLE_FROM = 1;
   */
  FROM = 1,

  /**
   * @generated from enum value: ROLE_TO = 2;
   */
  TO = 2,

  /**
   * @generated from enum value: ROLE_CC = 3;
   */
  CC = 3,

  /**
   * @generated from enum value: ROLE_BCC = 4;
   */
  BCC = 4,

  /**
   * @generated from enum value: ROLE_MENTION = 5;
   */
  MENTION = 5,

  /**
   * @generated from enum value: ROLE_SPEAKER = 6;
   */
  SPEAKER = 6,

  /**
   * @generated from enum value: ROLE_AUTHOR = 7;
   */
  AUTHOR = 7,
}

/**
 * Describes the enum lvdr.v2.inbox.Role.
 */
export const RoleSchema: GenEnum<Role> = /*@__PURE__*/
  enumDesc(file_inbox_inbox, 3);

/**
 * @generated from enum lvdr.v2.inbox.PartType
 */
export enum PartType {
  /**
   * @generated from enum value: PART_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PART_TYPE_AUTHORED_TEXT = 1;
   */
  AUTHORED_TEXT = 1,

  /**
   * @generated from enum value: PART_TYPE_QUOTED_TEXT = 2;
   */
  QUOTED_TEXT = 2,

  /**
   * @generated from enum value: PART_TYPE_TRANSCRIPT_SEGMENT = 3;
   */
  TRANSCRIPT_SEGMENT = 3,

  /**
   * @generated from enum value: PART_TYPE_ATTACHMENT_REF = 4;
   */
  ATTACHMENT_REF = 4,
}

/**
 * Describes the enum lvdr.v2.inbox.PartType.
 */
export const PartTypeSchema: GenEnum<PartType> = /*@__PURE__*/
  enumDesc(file_inbox_inbox, 4);

/**
 * ---- INBOX-02b WS control plane --------------------------------------------
 *
 * @generated from enum lvdr.v2.inbox.InboxErrorCode
 */
export enum InboxErrorCode {
  /**
   * @generated from enum value: INBOX_ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INBOX_ERROR_CODE_TLS_REQUIRED = 1;
   */
  TLS_REQUIRED = 1,

  /**
   * @generated from enum value: INBOX_ERROR_CODE_DESTINATION_BLOCKED = 2;
   */
  DESTINATION_BLOCKED = 2,

  /**
   * @generated from enum value: INBOX_ERROR_CODE_AUTH_FAILED = 3;
   */
  AUTH_FAILED = 3,

  /**
   * @generated from enum value: INBOX_ERROR_CODE_TIMEOUT = 4;
   */
  TIMEOUT = 4,

  /**
   * @generated from enum value: INBOX_ERROR_CODE_UNREACHABLE = 5;
   */
  UNREACHABLE = 5,

  /**
   * @generated from enum value: INBOX_ERROR_CODE_ALREADY_CONNECTED = 6;
   */
  ALREADY_CONNECTED = 6,

  /**
   * @generated from enum value: INBOX_ERROR_CODE_FEATURE_DISABLED = 7;
   */
  FEATURE_DISABLED = 7,

  /**
   * @generated from enum value: INBOX_ERROR_CODE_INVALID_INPUT = 8;
   */
  INVALID_INPUT = 8,

  /**
   * @generated from enum value: INBOX_ERROR_CODE_NOT_FOUND = 9;
   */
  NOT_FOUND = 9,

  /**
   * @generated from enum value: INBOX_ERROR_CODE_LIMIT_REACHED = 10;
   */
  LIMIT_REACHED = 10,

  /**
   * @generated from enum value: INBOX_ERROR_CODE_INTERNAL = 11;
   */
  INTERNAL = 11,

  /**
   * per-user probe limit (Test/Connect)
   *
   * @generated from enum value: INBOX_ERROR_CODE_RATE_LIMITED = 12;
   */
  RATE_LIMITED = 12,

  /**
   * sealed record fails to open (key changed); reconnect replaces it
   *
   * @generated from enum value: INBOX_ERROR_CODE_CREDENTIAL_UNREADABLE = 13;
   */
  CREDENTIAL_UNREADABLE = 13,

  /**
   * server cannot hold credentials (ephemeral key) or is shutting down — NOT a locked session
   *
   * @generated from enum value: INBOX_ERROR_CODE_UNAVAILABLE = 14;
   */
  UNAVAILABLE = 14,

  /**
   * a previous disconnect is still removing data, or a sync run / another Connect or Disconnect for this source is in flight (syncrun.ErrBusy, from Connect, Disconnect and Runner.Reply); retry shortly
   *
   * @generated from enum value: INBOX_ERROR_CODE_PURGE_PENDING = 15;
   */
  PURGE_PENDING = 15,

  /**
   * this user's stores are not open (encrypted, not yet unlocked); unlock and retry
   *
   * @generated from enum value: INBOX_ERROR_CODE_SESSION_LOCKED = 16;
   */
  SESSION_LOCKED = 16,

  /**
   * the owner's plan lacks the workflow capability (BILL-20d); FE renders PlanUpsell
   *
   * @generated from enum value: INBOX_ERROR_CODE_PLAN_UPGRADE_REQUIRED = 17;
   */
  PLAN_UPGRADE_REQUIRED = 17,

  /**
   * the stored task or conversation rules cannot be decoded; a confirm would overwrite them (INBOX-05c)
   *
   * @generated from enum value: INBOX_ERROR_CODE_RULES_UNREADABLE = 18;
   */
  RULES_UNREADABLE = 18,

  /**
   * INBOX-07: the conversation's kind has no reply channel (only email has one)
   *
   * @generated from enum value: INBOX_ERROR_CODE_NO_REPLY_CHANNEL = 19;
   */
  NO_REPLY_CHANNEL = 19,

  /**
   * INBOX-07: the conversation has no inbound mail to reply to
   *
   * @generated from enum value: INBOX_ERROR_CODE_NO_TARGET = 20;
   */
  NO_TARGET = 20,

  /**
   * INBOX-07 D23: the newest inbound mail was blocked by the inbound filter
   *
   * @generated from enum value: INBOX_ERROR_CODE_DRAFT_BLOCKED = 21;
   */
  DRAFT_BLOCKED = 21,

  /**
   * INBOX-07 D5: the generated draft carried payment or credential details; nothing was appended
   *
   * @generated from enum value: INBOX_ERROR_CODE_DRAFT_GUARD = 22;
   */
  DRAFT_GUARD = 22,

  /**
   * INBOX-07 D34: the model call exceeded its budget; nothing was appended
   *
   * @generated from enum value: INBOX_ERROR_CODE_DRAFT_TIMEOUT = 23;
   */
  DRAFT_TIMEOUT = 23,

  /**
   * INBOX-22: the conversation rules changed since the client read them; nothing was written, reload
   *
   * @generated from enum value: INBOX_ERROR_CODE_RULES_STALE = 24;
   */
  RULES_STALE = 24,

  /**
   * INBOX-13a D46: the Telegram source needs a usable always-on space
   *
   * @generated from enum value: INBOX_ERROR_CODE_NO_ALWAYS_ON_SPACE = 25;
   */
  NO_ALWAYS_ON_SPACE = 25,

  /**
   * INBOX-13a: the Telegram account that sent /start is linked to another user
   *
   * @generated from enum value: INBOX_ERROR_CODE_TELEGRAM_ALREADY_LINKED = 26;
   */
  TELEGRAM_ALREADY_LINKED = 26,
}

/**
 * Describes the enum lvdr.v2.inbox.InboxErrorCode.
 */
export const InboxErrorCodeSchema: GenEnum<InboxErrorCode> = /*@__PURE__*/
  enumDesc(file_inbox_inbox, 5);

/**
 * @generated from enum lvdr.v2.inbox.InboxSyncState
 */
export enum InboxSyncState {
  /**
   * @generated from enum value: INBOX_SYNC_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INBOX_SYNC_STATE_SYNCING = 1;
   */
  SYNCING = 1,

  /**
   * @generated from enum value: INBOX_SYNC_STATE_IDLE = 2;
   */
  IDLE = 2,

  /**
   * rejected: the user must fix the configuration
   *
   * @generated from enum value: INBOX_SYNC_STATE_PAUSED = 3;
   */
  PAUSED = 3,

  /**
   * @generated from enum value: INBOX_SYNC_STATE_ERROR = 4;
   */
  ERROR = 4,
}

/**
 * Describes the enum lvdr.v2.inbox.InboxSyncState.
 */
export const InboxSyncStateSchema: GenEnum<InboxSyncState> = /*@__PURE__*/
  enumDesc(file_inbox_inbox, 6);

/**
 * INBOX-13a: the Telegram source's link state, as the connect screen shows it (design §10).
 *
 * @generated from enum lvdr.v2.inbox.InboxTelegramLinkState
 */
export enum InboxTelegramLinkState {
  /**
   * @generated from enum value: INBOX_TELEGRAM_LINK_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INBOX_TELEGRAM_LINK_STATE_NOT_LINKED = 1;
   */
  NOT_LINKED = 1,

  /**
   * a live /start token exists
   *
   * @generated from enum value: INBOX_TELEGRAM_LINK_STATE_AWAITING_START = 2;
   */
  AWAITING_START = 2,

  /**
   * awaiting /start, but no live token
   *
   * @generated from enum value: INBOX_TELEGRAM_LINK_STATE_TOKEN_EXPIRED = 3;
   */
  TOKEN_EXPIRED = 3,

  /**
   * /start done; add the bot in Chat Automation
   *
   * @generated from enum value: INBOX_TELEGRAM_LINK_STATE_AWAITING_CONNECTION = 4;
   */
  AWAITING_CONNECTION = 4,

  /**
   * @generated from enum value: INBOX_TELEGRAM_LINK_STATE_CONNECTED = 5;
   */
  CONNECTED = 5,

  /**
   * the bot is off in Chat Automation (D6, D10)
   *
   * @generated from enum value: INBOX_TELEGRAM_LINK_STATE_PAUSED = 6;
   */
  PAUSED = 6,

  /**
   * not linked and no usable always-on space (D46)
   *
   * @generated from enum value: INBOX_TELEGRAM_LINK_STATE_NO_ALWAYS_ON_SPACE = 7;
   */
  NO_ALWAYS_ON_SPACE = 7,
}

/**
 * Describes the enum lvdr.v2.inbox.InboxTelegramLinkState.
 */
export const InboxTelegramLinkStateSchema: GenEnum<InboxTelegramLinkState> = /*@__PURE__*/
  enumDesc(file_inbox_inbox, 7);

/**
 * @generated from enum lvdr.v2.inbox.TriageBucket
 */
export enum TriageBucket {
  /**
   * triage hidden (inbox_triage off), a CALL conversation, or no label
   *
   * @generated from enum value: TRIAGE_BUCKET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRIAGE_BUCKET_NEEDS_ME = 1;
   */
  NEEDS_ME = 1,

  /**
   * @generated from enum value: TRIAGE_BUCKET_WAITING = 2;
   */
  WAITING = 2,

  /**
   * @generated from enum value: TRIAGE_BUCKET_FYI = 3;
   */
  FYI = 3,

  /**
   * @generated from enum value: TRIAGE_BUCKET_NOISE = 4;
   */
  NOISE = 4,
}

/**
 * Describes the enum lvdr.v2.inbox.TriageBucket.
 */
export const TriageBucketSchema: GenEnum<TriageBucket> = /*@__PURE__*/
  enumDesc(file_inbox_inbox, 8);

/**
 * ---- INBOX-07: reply draft ----
 *
 * @generated from enum lvdr.v2.inbox.DraftContextState
 */
export enum DraftContextState {
  /**
   * @generated from enum value: DRAFT_CONTEXT_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DRAFT_CONTEXT_STATE_READY = 1;
   */
  READY = 1,

  /**
   * D23
   *
   * @generated from enum value: DRAFT_CONTEXT_STATE_BLOCKED = 2;
   */
  BLOCKED = 2,

  /**
   * every non-email kind
   *
   * @generated from enum value: DRAFT_CONTEXT_STATE_NO_REPLY_CHANNEL = 3;
   */
  NO_REPLY_CHANNEL = 3,

  /**
   * @generated from enum value: DRAFT_CONTEXT_STATE_NO_TARGET = 4;
   */
  NO_TARGET = 4,
}

/**
 * Describes the enum lvdr.v2.inbox.DraftContextState.
 */
export const DraftContextStateSchema: GenEnum<DraftContextState> = /*@__PURE__*/
  enumDesc(file_inbox_inbox, 9);

